import { render, staticRenderFns } from "./AppPane8.vue?vue&type=template&id=327df542&scoped=true&"
import script from "./AppPane8.vue?vue&type=script&lang=js&"
export * from "./AppPane8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327df542",
  null
  
)

export default component.exports